<template>
	<div class="interactive absolute inset-0 flex flex-col items-center justify-center s-fill">
		<!-- Interactive SVG -->
		<div class="z-0 flex flex-col items-center justify-center s-fill" v-if="node && assets && assets[node.node_content]">
			<div class="svg s-fill" v-if="svg" v-html="svg"></div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'

	export default {
		name: 'Interactive',
		props: {
			node: {
				type: Object,
				required: false,
				default: null
			},
			assets: {
				type: Object,
				required: true,
				default: () => {},
			}
		},
		data() {
			return {
				svg: null,
			}
		},
		watch: {
			node: {
				handler(node) {
					// Reset states
					this.svg = null

					if (!node)
						return

					// Load SVG content, if needed
					const asset = this.assets[node.node_content]
					if (asset && asset.path && asset.path.indexOf('svg') > -1) {
						axios(asset.url).then((response) => {
							this.svg = response.data

							// Add click listener to all overlay elements
							this.$nextTick(() => {
								// Get interactive svg groups/element
								let container = document.getElementById('faa-int')

								// Try another potential container
								if (!container) {
									container = document.getElementById('faa-int-overlay')
								}

								if (container) {
									const children = container.childNodes

									for (var i = 0; i < children.length; i++) {
										children[i].addEventListener('click', this.triggerClick)
									}
								}
							})
						})
					}
				},
				immediate: true,
			},
		},
		methods: {
			triggerClick(event) {
				if (!this.node.triggers_by_type.interactive_trigger || this.node.triggers_by_type.interactive_trigger.length <= 0)
					return
				
				if (event && event.currentTarget) {
					// Get id to create expected trigger name and find this name in the current node triggers
					const name = 'faa_int_' + event.currentTarget.id
					const trigger = this.node.triggers_by_type.interactive_trigger.find((trigger) => (trigger.name == name))

					if (trigger) {
						this.$emit('trigger', trigger)
					}
				}
			}
		}
	}
</script>

<style lang="scss">
.interactive {
	svg {
		width: 100%;
		height: 100%;
		max-width: 100%;
		max-height: 100%;

		& > * {
			pointer-events: none;
		}
	}

	#faa-int {
		pointer-events: none;
		transform: translateZ(0);

		& > * {
			pointer-events: all;
			transform: translateZ(0);
			cursor: pointer;
		}
	}

	#faa-int-overlay {
		pointer-events: none;
		transform: translateZ(0);

		& > * {
			pointer-events: all;
			transform: translateZ(0);
			cursor: pointer;
			opacity: 0;
			transition: opacity 0.3s;

			&:hover {
				opacity: 1;
			}
		}

		// Disable pointer events on element only used as overlay
		[id|="hover"] {
			pointer-events: none;
		}
	}
}
</style>
